import { Paper, Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { NoResults } from '@common/ui/NoResults';
import { Children, PropsWithChildren } from 'react';

export default function TokensTable({ children }: PropsWithChildren) {
  if (Children.count(children) === 0) {
    return <NoResults>No tokens found</NoResults>;
  }

  return (
    <TableContainer component={Paper} elevation={0}>
      <MuiTable size="small">
        <TableHead>
          <TableRow>
            {['Name', 'Token', 'Create Date', ''].map((column, index) => (
              <TableCell component="th" size="medium" key={`th-${index}`}>
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </MuiTable>
    </TableContainer>
  );
}
